// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1480":"49b5582e3ab4db78","8361":"f9da4489530d255e","8390":"f189a404b3a041a4"}[chunkId] + ".js";
};